import { useEffect, useState } from "react";
import { PageHero } from "../components/common/PageHero";
import { Reveal } from "../components/common/Reveal";
import { api } from "../lib/api";
import { usePageMeta } from "../lib/usePageMeta";

export const PolicyPage = ({ slug, fallbackTitle }) => {
    const [page, setPage] = useState(null);
    usePageMeta(`${page?.title || fallbackTitle} — Showtime Carnival Co.`, `${page?.title || fallbackTitle} for Showtime Carnival Co., NYC.`);

    useEffect(() => {
        setPage(null);
        api.get(`/pages/${slug}`).then((res) => setPage(res.data)).catch(() => setPage({ title: fallbackTitle, content: "This page is being finalized." }));
    }, [slug]);

    return (
        <>
            <PageHero kicker="Showtime Carnival Co." title={page?.title || fallbackTitle} dark={false} testid={`policy-${slug}-hero`} />
            <section className="bg-white py-16 md:py-24">
                <div className="mx-auto max-w-3xl px-5 md:px-10">
                    <Reveal>
                        {page?.needs_review && (
                            <p className="mb-8 inline-block rounded-full bg-pink-soft px-5 py-2 text-xs font-bold tracking-[0.2em] uppercase text-pink-dark" data-testid={`policy-${slug}-draft-badge`}>
                                Being finalized by our team
                            </p>
                        )}
                        <div className="space-y-5 text-zinc-600 text-sm md:text-base leading-relaxed" data-testid={`policy-${slug}-content`}>
                            {(page?.content || "").split("\n\n").filter(Boolean).map((para, i) => (
                                <p key={i}>{para}</p>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
};
